import _ from 'lodash'

export const hasPermission = (permissions, key) => {
  return _.includes(permissions, key)
}

export const hasModuleAccess = (userData, moduleCode) => {
  return hasPermission(userData?._pis?.groupModuleList, moduleCode)
}

export const hasTokenPermission = (permission, code) => {
  const permissionValue = permission?.[code]

  if (permissionValue === true) {
    return true
  }

  if (permissionValue && typeof permissionValue === 'object') {
    return Boolean(permissionValue.isView)
  }

  return false
}

export const hasAnyTokenPermission = (permission, codes = []) => {
  return codes.some((code) => hasTokenPermission(permission, code))
}

export const hasMainModulePermission = (
  userData,
  permission,
  moduleCode,
  permissionCodes
) => {
  return (
    hasModuleAccess(userData, moduleCode) &&
    hasAnyTokenPermission(permission, permissionCodes)
  )
}
